<template>
  <div>
    <component
      :is="getComponent(component._type)"
      v-for="component in sectionBuilder"
      :key="component._key"
      :value="component"
    />
  </div>
</template>
<script setup lang="ts">
import { getComponent } from '~/components/Mapper';
import type {
  AnchorMenuSectionBuilder,
  MediaTwoColumnSectionBuilder,
  GenericSectionBuilder,
  ProductSectionBuilder,
  SignupPartialViewsSectionBuilder,
  HomepageSectionBuilder,
} from '~/sanity/types';
type PropsType =
  | AnchorMenuSectionBuilder
  | MediaTwoColumnSectionBuilder
  | GenericSectionBuilder
  | ProductSectionBuilder
  | SignupPartialViewsSectionBuilder
  | HomepageSectionBuilder;
defineProps<PropsType>();
</script>

<style lang="scss" scoped></style>
